import ScentSelector from './ScentSelector.portal';
export default ScentSelector